import { supabase } from '../supabaseClient';

export interface GeneratedDocument {
  id: string;
  name: string;
  url: string;
  downloadUrl?: string;
}

export const documentService = {
  async generateContractDocument(contractId: string): Promise<GeneratedDocument> {
    const session = await supabase.auth.getSession();
    const token = session.data.session?.access_token;

    if (!token) {
      throw new Error('Not authenticated');
    }

    const response = await fetch(
      `${import.meta.env.VITE_SUPABASE_URL}/functions/v1/generate-contract-document`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({ contractId }),
      }
    );

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || 'Failed to generate document');
    }

    const data = await response.json();
    return data.document;
  },
};

